export default "__VITE_ASSET__BJl$ZM2i__"